export const messages = {
  en: {
    contractApplyAuditHistoryOrders: {
      title: 'Draft Completed Orders',
      contractCode: 'Contract Number',
      contractName: 'Contract Name',
      contractType: 'Contract Type',
      contractStatus: 'Contract Status',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      fetchError: 'Failed to fetch contract history orders',
      page: {
        subtitle: 'View completed draft contract orders',
        empty: 'No completed draft orders found',
        loadFailed: 'Failed to fetch contract history orders'
      }
    }
  },
  zh: {
    contractApplyAuditHistoryOrders: {
      title: '起草已办单',
      contractCode: '合同编号',
      contractName: '合同名称',
      contractType: '合同类型',
      contractStatus: '合同状态',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      fetchError: '获取合同历史订单失败',
      page: {
        subtitle: '查看已办结的起草合同单据',
        empty: '暂无已办起草单',
        loadFailed: '获取合同历史订单失败'
      }
    }
  }
}